import React, { useState } from "react"
import posed, { PoseGroup } from "react-pose"
import styled from "../styled"
import { FaCog } from "react-icons/fa"
import { Button, Flex } from "@jjordy/layout"
import uuid from "uuid"

const MyButton = styled(Button)`
  background-color: transparent !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
`

const SlideInPanel = posed.div({
  enter: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 }
})

const RotateIcon = posed.div({
  open: { rotate: -90 },
  closed: { rotate: 90 }
})

export interface ExpandoMenuProps {
  children?: React.ReactNode | string
}

const ExpandoMenu: React.SFC<ExpandoMenuProps> = ({ children }) => {
  const [open, toggleOpen] = useState(false)
  return (
    <Flex p={0} align="center">
      <PoseGroup>{open && <SlideInPanel key={uuid.v4()}>{children}</SlideInPanel>}</PoseGroup>
      <MyButton onClick={() => toggleOpen(!open)} type="button">
        <RotateIcon pose={open ? "open" : "closed"}>
          <FaCog style={{ margin: 0 }} />
        </RotateIcon>
      </MyButton>
    </Flex>
  )
}

export default ExpandoMenu
